module.exports = __webpack_public_path__ + "static/media/featured-star.4d4852e7.svg";